import { z } from "zod";

export const schema = z.object({
  phone: z
    .string()
    .min(1, "El número de teléfono es obligatorio")
    //format: 0000-0000
    .regex(
      /^\d{4} \d{4}$/,
      "El número de teléfono debe tener el formato 0000 0000",
    ),
});
export type UpdateProfileFormData = z.infer<typeof schema>;
